import React from 'react'

const RotateIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <path
            d="M20.4 7.2001V8.4001H19.2L21 11.5201L22.8 8.4001H21.6V7.2001C21.6 5.2201 19.98 3.6001 18 3.6001H15.6V4.8001H18C19.32 4.8001 20.4 5.8801 20.4 7.2001ZM18 16.8001H6.00001V7.2001H18V16.8001ZM7.20001 8.4001V15.6001H16.8V8.4001H7.20001ZM8.40001 19.2001V20.4001H6.00001C4.02001 20.4001 2.40001 18.7801 2.40001 16.8001V15.6001H1.20001L3.00001 12.4801L4.80001 15.6001H3.60001V16.8001C3.60001 18.1201 4.68001 19.2001 6.00001 19.2001H8.40001Z"
            fill="black"
        />
    </svg>
)

export default RotateIcon
